import { AnyAction } from 'redux';
import { AddVertragToAngebote, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, PhVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { PhActions } from '../phActions';

export interface Vorschaeden {
  vorhanden: boolean | null;
  phVorschaeden: number;
}

export const vorschaedenReducer = function (
  sectionState: Vorschaeden = null,
  action: AnyAction,
): Vorschaeden {
  switch (action.type) {
    case PhActions.VORSCHAEDEN_VORHANDEN: {
      return {
        ...sectionState,
        phVorschaeden: 0,
        vorhanden: action.payload,
      };
    }
    case PhActions.VORSCHADEN_VALUE_CHANGED: {
      const { vorschadenId, value } = action.payload;
      return { ...sectionState, [vorschadenId]: value };
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      const actionPayload: AddVertragToAngebote = action.payload;
      if (actionPayload.appId === App.PH && action.payload.vorvertragsNummern) {
        return {
          ...sectionState,
          phVorschaeden: 0,
          vorhanden: false,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: PhVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.PH) {
        return {
          ...sectionState,
          phVorschaeden: actionPayload.anzVorschaeden,
          vorhanden: actionPayload.anzVorschaeden > 0,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
